import styled from 'styled-components';
import { Link } from 'react-router-dom';
import withErrorHandling from 'enhancers/withErrorHandling';
import { space, layout } from 'styled-system';

export const ButtonLink = styled(Link)(({ theme }) => `
  display: inline-block;
  text-decoration: none;
  color: ${theme.colors.dark};
  border: ${theme.strokes.medium} solid ${theme.colors.utility.primary};
  border-radius: 0;
  line-height: 3rem;
  padding: 0 1rem;
  margin-bottom: 1rem;
  font-size: 15px;
  transition:
    transform ${theme.speeds.fast},
    color ${theme.speeds.fast},
    background-color ${theme.speeds.fast},
    border ${theme.speeds.fast};

  &:active {
    transform: scale(0.95);
  }
  &:active:disabled {
    transform: none;
  }
  &.primary {
    color: ${theme.colors.white};
    background: ${theme.colors.utility.primary};
  }
  &.primary:disabled {
    border-color: ${theme.colors.utility.secondary};
    color: ${theme.colors.utility.ultralight};
    background: ${theme.colors.utility.secondary};
    cursor: not-allowed;
  }
  &.secondary {
    color: ${theme.colors.utility.primary};
    background: ${theme.colors.white};
  }
`, space, layout);

export const Button = styled.button(({ theme }) => `
  border: ${theme.strokes.medium} solid ${theme.colors.utility.primary};
  background: transparent;
  border-radius: 0;
  line-height: 3rem;
  padding: 0 1rem;
  margin-bottom: 1rem;
  font-size: 15px;
  transition:
    transform ${theme.speeds.fast},
    color ${theme.speeds.fast},
    background-color ${theme.speeds.fast},
    border ${theme.speeds.fast};

  &:active {
    transform: scale(0.95);
  }
  &:active:disabled {
    transform: none;
  }
  &.primary {
    color: ${theme.colors.white};
    background: ${theme.colors.utility.primary};
  }
  &.primary:disabled {
    border-color: ${theme.colors.utility.secondary};
    color: ${theme.colors.utility.ultralight};
    background: ${theme.colors.utility.secondary};
    cursor: not-allowed;
  }
  &.secondary {
    color: ${theme.colors.utility.primary};
    background: ${theme.colors.white};
  }
`, space, layout);

export const TextButton = styled.button(({ theme }) => `
  display: inline;
  padding: 0;
  margin: 0;
  outline: none;
  border: none;
  background: none;
  color: ${theme.colors.utility.secondary};
  text-decoration: underline;
  cursor: pointer;

  &:disabled {
    color: ${theme.colors.utility.light};
    cursor: not-allowed;
  }
`, space, layout);

export const KeyboardInput = styled.input(() => `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: none;
  border: none;
  outline: none;
  color: inherit;
  opacity: 0;
  text-align: center;
  &:focus, &:focus-visible {
    outline: none;
    border: none;
  }
`, space, layout);

export const Input = withErrorHandling(styled.input(({ theme, fluid }) => `
  width: ${fluid ? '100%' : 'unset'};
  margin-bottom: 1rem;
  padding: 0 1rem;
  line-height: 3rem;
  background: ${theme.colors.utility.ghost};
  border: none;
  border-bottom: ${theme.strokes.medium} solid ${theme.colors.utility.primary};
  border-radius: 0;
  outline: none;
  &:focus {
    background: ${theme.colors.utility.ultralight};
  }
  ::placeholder {
    color: ${theme.colors.utility.secondary};
  }
`, space));

export const TextArea = styled.textarea(({ theme, fluid }) => `
  width: ${fluid ? '100%' : 'unset'};
  margin-bottom: 1rem;
  line-height: 2rem;
  height: 9rem;
  background: ${theme.colors.utility.ghost};
  border: none;
  padding: 0.5rem 1rem 1rem;
  border-bottom: ${theme.strokes.medium} solid ${theme.colors.utility.primary};
  border-radius: 0;
  outline: none;
  resize: none;
  font-family: ${theme.fontFamilies.body};
  &:focus {
    background: ${theme.colors.utility.ultralight};
  }
  ::placeholder {
    color: ${theme.colors.utility.secondary};
  }
`);
